import React, {useEffect} from 'react'
import {ComponentEnum, ComponentNameEnum} from './componentsRegistry/Registry'
import {Toolbar} from './toolbar/Toolbar'
import {ToolbarButtonImg} from './toolbar/ToolbarButtonImg'
import {useDispatch, useSelector} from 'react-redux'
import {IReduxState} from '../../redux/types/IReduxState'
import {taskActions} from './redux/actions'
import {ToolbarTab} from './toolbar/ToolbarTab'
import {ToolbarGroupTab} from './toolbar/ToolbarGroupTab'
import {acArrowCollapse, acArrowExpand} from 'ac-icon'
import {WindowContent} from './components/window/WindowContent'
import {TaskDrawerModal} from './components/drawer/TaskDrawerModal'

interface ITaskFullscreenLayoutProps {
  onSetWindowStyle: (newStyle: number) => void
}

const TaskFullscreenLayout: React.FC<ITaskFullscreenLayoutProps> = ({onSetWindowStyle}) => {
  const taskDispatch = useDispatch()
  const isSplitMode = useSelector<IReduxState, boolean>((state) => state.task?.isSplitMode)
  const leftComponentId = useSelector<IReduxState, ComponentEnum | undefined>(
    (state) => state.task?.fullscreenLeftComponentId,
  )
  const rightComponentId = useSelector<IReduxState, ComponentEnum | undefined>(
    (state) => state.task?.fullscreenRightComponentId,
  )
  const fullscreenActiveLeftComponentId = useSelector<IReduxState, ComponentEnum | undefined>(
    (state) => state.task?.fullscreenActiveLeftComponentId,
  )
  const fullscreenActiveRightComponentId = useSelector<IReduxState, ComponentEnum | undefined>(
    (state) => state.task?.fullscreenActiveRightComponentId,
  )

  const exitFullscreen = (): void => {
    taskDispatch(taskActions.changeFullscreenMode(false, false, null, null, undefined, undefined))
  }

  const closeFullscreen = (evt): void => {
    if (evt.key === 'Escape') {
      exitFullscreen()
    }
  }
  useEffect(() => {
    document.addEventListener('keydown', closeFullscreen)
    return () => {
      document.removeEventListener('keydown', closeFullscreen)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const splitTabs = (splitLeftComponentId: ComponentEnum, splitRightComponentId: ComponentEnum): void => {
    taskDispatch(
      taskActions.changeFullscreenMode(true, true, splitLeftComponentId, splitRightComponentId, undefined, undefined),
    )
  }

  const leftComponent = (
    <WindowContent
      id={leftComponentId}
      componentId={leftComponentId}
      innerActiveComponentId={fullscreenActiveLeftComponentId}
      onClickInnerToolbarTab={(currentId) => {
        taskDispatch(taskActions.setFullscreenActiveLeftComponentId(currentId))
      }}
      splitTabs={splitTabs}
      isScrollContainer={leftComponentId === ComponentEnum.schemaDiagram}
      className={'h-100'}
    />
  )
  const rightComponent = (
    <WindowContent
      id={rightComponentId}
      componentId={rightComponentId}
      innerActiveComponentId={fullscreenActiveRightComponentId}
      onClickInnerToolbarTab={(currentId) => {
        taskDispatch(taskActions.setFullscreenActiveRightComponentId(currentId))
      }}
      splitTabs={splitTabs}
      isScrollContainer={rightComponentId === ComponentEnum.schemaDiagram}
      className={'h-100'}
    />
  )

  let cssLeft = 'task-fullscreen-tab-body custom-scroll pb-0 pt-x2 pr-x1 pl-x2'
  let cssRight = 'task-fullscreen-tab-body custom-scroll pb-0 pt-x2 pr-x1 pl-x2'

  if (
    leftComponentId === ComponentEnum.masterResult ||
    leftComponentId === ComponentEnum.myResult ||
    leftComponentId === ComponentEnum.editor ||
    leftComponentId === ComponentEnum.solution ||
    leftComponentId === ComponentEnum.schema ||
    leftComponentId === ComponentEnum.description
  ) {
    cssLeft = 'task-fullscreen-tab-body custom-scroll p-0'
  }

  if (
    rightComponentId === ComponentEnum.masterResult ||
    rightComponentId === ComponentEnum.myResult ||
    rightComponentId === ComponentEnum.editor ||
    rightComponentId === ComponentEnum.solution ||
    rightComponentId === ComponentEnum.schema ||
    rightComponentId === ComponentEnum.description
  ) {
    cssRight = 'task-fullscreen-tab-body custom-scroll p-0'
  }
  return (
    <div className={'task-editor-layout'}>
      <div className={'task-editor-half-width-column'}>
        <div>
          <Toolbar>
            <ToolbarGroupTab>
              <ToolbarTab name={ComponentNameEnum[leftComponentId]} isActive={true} />
            </ToolbarGroupTab>
            <ToolbarButtonImg
              title={isSplitMode ? 'Свернуть' : 'Развернуть'}
              onClick={exitFullscreen}
              iconPath={isSplitMode ? acArrowCollapse : acArrowExpand}
            />
          </Toolbar>
          <div className={cssLeft}>{leftComponent}</div>
        </div>
      </div>
      <div className={'task-editor-half-width-column'}>
        <div>
          <Toolbar>
            <ToolbarGroupTab>
              <ToolbarTab name={ComponentNameEnum[rightComponentId]} isActive={true} />
            </ToolbarGroupTab>
            <ToolbarButtonImg
              title={isSplitMode ? 'Свернуть' : 'Развернуть'}
              onClick={exitFullscreen}
              iconPath={isSplitMode ? acArrowCollapse : acArrowExpand}
            />
          </Toolbar>
          <div className={cssRight}>{rightComponent}</div>
        </div>
      </div>
      <TaskDrawerModal onSetWindowStyle={onSetWindowStyle} />
    </div>
  )
}

export {TaskFullscreenLayout}
